import { totalUnitGroupArea } from "@/utils/unit_groups";
import { ClientUnitGroup } from "@shared/types/unitGroup";

export const totalUnitGroupGIA = (unitGroup: ClientUnitGroup): number =>
  (totalUnitGroupArea(unitGroup) * unitGroup.percentGIA) / 100;
